export class RowValidState {

    /**
     * @type {Map<MetaColumn, ColumnValidState>}
     */
    columnMap = new Map();
    valid = true;
    /**
     * hat die row einen transitiven Fehler?
     */
    transValid = true;
    /**
     * @type {TransSource}
     */
    transSource = null;

}
